import analyticsService from "./AnalyticsService";
import { ANALYTICS_EVENTS, resolveEnvironment } from "./constants";
import { resolvePageTitle } from "./utils/resolvePageName";
import { claimInteraction } from "./utils/interactionMetadata";

// Most clicks, navigation, popups, accordions, pagination and search are
// reported automatically by the global interaction tracker. Use these helpers
// only for business events the DOM cannot describe on its own.

const getDefaultAuthEventParams = () => ({
  environment: analyticsService?.context?.environment || resolveEnvironment(),
  page_title:
    resolvePageTitle(
      `${globalThis?.location?.pathname || ""}${globalThis?.location?.search || ""}`,
    ) ||
    document?.title ||
    "Application Page",
});

export const trackEvent = (eventName, params = {}, options = {}) => {
  if (
    eventName === ANALYTICS_EVENTS.UI_INTERACTION ||
    eventName === ANALYTICS_EVENTS.SELECT_CONTENT
  ) {
    if (options.nativeInteraction !== false) claimInteraction();
  }
  analyticsService.track(eventName, params, options);
};

export const trackUIInteraction = (
  interactionType,
  params = {},
  options = {},
) =>
  trackEvent(
    ANALYTICS_EVENTS.UI_INTERACTION,
    {
      ...params,
      interaction_type: interactionType,
    },
    options,
  );

export const trackSelectContent = (params = {}) =>
  trackEvent(ANALYTICS_EVENTS.SELECT_CONTENT, {
    content_type: params.element_type || "item",
    interaction_type: "selected",
    ...params,
  });

export const trackDownload = (params = {}) =>
  trackEvent(ANALYTICS_EVENTS.FILE_DOWNLOAD, params);

export const trackSignOut = (params = {}) =>
  trackUIInteraction(
    "sign_out",
    {
      ...getDefaultAuthEventParams(),
      ...params,
    },
    { dedupe: false },
  );
